// the Uniswap Default token list lives here
export const DEFAULT_TOKEN_LIST_URL = 'https://tokenlist.pages.dev/shitswap.json'

export const DEFAULT_LIST_OF_LISTS: string[] = [
  DEFAULT_TOKEN_LIST_URL
]
